import type { FormField } from '../../types';
interface Props { field: FormField; value: unknown; onChange: (v: unknown) => void; error?: string; }
export function HiddenField({ field, value }: Props) {
  return <input type="hidden" name={field.fieldId} value={String(value ?? '')} />;
}
